
















































































































import { Component, Vue } from "vue-property-decorator";
@Component({})
export default class FlightChangeChecklist extends Vue {
  mockData: any[] = [];
  headers: any[] = [];
  startDate: Date = null;
  breadcrumbsItems: any[] = [];
  active_tab: number = 0;
  checkbox: boolean = false;

  created() {
    (this.headers = [
      { text: "Kime", value: "to" },
      { text: "İletildi mi", value: "delivered" },
      { text: "İletilme Saati", value: "deliveredTime" },
      { text: "Okundu mu", value: "reading" },
      { text: "Okunma Saati", value: "readingTime" },
    ]),
      (this.mockData = [
        {
          to: "jdfkjdfkjf ",
          delivered: "evet ",
          deliveredTime: "17:00 ",
          reading: "evet",
          readingTime: "20:00",
        },
      ]),
      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Uçuş", disabled: true },
        { text: "Uçuş Değişim Kontrol Listesi", disabled: true },
      ]);
  }

  data() {
    return {
      page: 1,

      fromAirportsItems: ["Anapa,Rusya / AAQ", "Abakan,Rusya / ABA"],
      fromAirports: [],

      toAirportsItems: [
        "Antalya,Turkey (AYT-Antalya Int) / AYT",
        "Akabe,Urdun / AQJ",
      ],
      toAirports: [],
    };
  }
}
